/*eslint-disable*/
// 获取mode
export const getMode = (langid) => {
  var id = parseInt(langid)
  var mode = []
  switch (id) {
    case 4:
      mode = 'text/x-python'
      break
    case 10:
      mode = 'text/x-java'
      break
    case 11:
      mode = 'text/x-csrc'
      break
    case 29:
      mode = 'text/x-php'
      break
    case 35:
      mode = 'text/html'
      break
    case 40:
      mode = 'text/x-sql'
      break
    case 43:
      mode = 'text/x-objectivec'
      break
    case 82:
      mode = 'text/x-c++src'
      break
    case 117:
      mode = 'text/x-rsrc'
      break
    default:
      break
  }
  return mode
}

export const getUrlParam = name => {
  var hash = window.location.hash.split("?")[1];
  if(hash) {
    var result = hash.match(new RegExp("(^|&)"+ name +"=([^&]*)(&|$)"));
    if(result != null) {
        return  decodeURIComponent(result[2]);
    } else {
        return null;
    }
  }
  // let search = window.location.search
  // if (search) {
  //   var result = search.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
  //   if (result == null || result.length < 1)
  //       return undefined;
  //   return decodeURIComponent(result[1]);
  // } else {
  //   var hash = window.location.hash.split("?")[1];
  //   if(hash) {
  //     var result = hash.match(new RegExp("(^|&)"+ name +"=([^&]*)(&|$)"));
  //     if(result != null) {
  //         return  decodeURIComponent(result[2]);
  //     } else {
  //         return null;
  //     }
  //   }
  // }
}

export const param = (data) => {
  // url += (url.indexOf('?') < 0 ? '?' : '&') + param(data)
  let url = ''
  for(let k in data){
    let value = data[k] !== undefined ? data[k] : ''
    url += `&${k}=${encodeURIComponent(value)}`
  }
  return url ? url.substring(1) : ''
}


// 生成uuid
export const generateUUID = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}





// WEBPACK FOOTER //
// ./src/common/js/utils.js